import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import bwipjs from "bwip-js";
import axios from "@/includes/connection";

export async function generateComprobant(data) {
  try {
    //const { data } = await axios.get(`/pdf/comprobant/${enrolledId}`);

    const myEncode = `${data.id}|${data.enrollment_id}|${data.document}|${data.complement}`;

    const qrCanvas = document.createElement("canvas");
    await bwipjs.toCanvas(qrCanvas, {
      bcid: "qrcode",
      text: myEncode.toString(),
      scale: 3,
    });
    const qrBase64 = qrCanvas.toDataURL("image/png");

    const existingPdfBytes = await fetch("/comprobante_V2.pdf").then((res) =>
      res.arrayBuffer()
    );
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const page = pdfDoc.getPages()[0];
    const qrImage = await pdfDoc.embedPng(qrBase64);

    //const titleLines = titleLn(String(data.title), 40);

    await titleLn(page, pdfDoc, String(data.title).toUpperCase(), 700, 8);

    //page.drawText(" | ", { x: 400, y: 720, size: 6 });
    //page.drawText(" | ", { x: 580, y: 720, size: 6 });

    page.drawText(String(data.code), { x: 230, y: 647, size: 8 });
    page.drawText(String(data.document), { x: 230, y: 635, size: 8 });
    page.drawText(String(data.fullname), { x: 230, y: 623, size: 8 });
    page.drawText(String(data.phone), { x: 230, y: 611, size: 8 });
    page.drawText(String(data.mail), { x: 230, y: 599, size: 8 });
    page.drawText(String(data.department), { x: 230, y: 587, size: 8 });
    page.drawText(String(data.service), { x: 230, y: 575, size: 8 });
    page.drawText(String(data.place_mode), { x: 230, y: 563, size: 8 });

    page.drawImage(qrImage, { x: 510, y: 422, width: 64, height: 64 });

    await titleLn(page, pdfDoc, String(data.title).toUpperCase(), 327, 8);

    page.drawText(String(data.code), { x: 230, y: 274, size: 8 });
    page.drawText(String(data.document), { x: 230, y: 262, size: 8 });
    page.drawText(String(data.fullname), { x: 230, y: 249, size: 8 });
    page.drawText(String(data.phone), { x: 230, y: 238, size: 8 });
    page.drawText(String(data.mail), { x: 230, y: 226, size: 8 });
    page.drawText(String(data.department), { x: 230, y: 214, size: 8 });
    page.drawText(String(data.service), { x: 230, y: 202, size: 8 });
    page.drawText(String(data.place_mode), { x: 230, y: 190, size: 8 });

    page.drawImage(qrImage, { x: 510, y: 50, width: 64, height: 64 });

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    //window.open(url, "_blank");

    const link = document.createElement("a");
    link.href = url;
    link.download = `comprobante_${data.document}.pdf`;
    link.click();
  } catch (error) {
    console.error("Error generando comprobante:", error);
  }
}

async function titleLn(page, pdfDoc, text, init, ln) {
  try {
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const fontSize = 6;
    const maxWidth = 230;

    const words = text.split(" ");
    const lines = [];
    let currentLine = "";

    for (let word of words) {
      const testLine = currentLine ? currentLine + " " + word : word;
      const width = font.widthOfTextAtSize(testLine, fontSize);
      if (width > maxWidth) {
        lines.push(currentLine);
        currentLine = word;
      } else {
        currentLine = testLine;
      }
    }
    if (currentLine) lines.push(currentLine);

    if (lines.length === 1) {
      const tamanoText = font.widthOfTextAtSize(lines[0], fontSize);
      page.drawText(lines[0], {
        x: 580 - tamanoText,
        y: init,
        size: fontSize,
        font,
      });
    } else {
      init = init + lines.length * ln - ln;
      lines.forEach((line, i) => {
        const tamanoText = font.widthOfTextAtSize(lines[i], fontSize);
        page.drawText(line.trimEnd(), {
          x: 580 - tamanoText,
          y: init - i * ln,
          size: fontSize,
          font,
        });
      });
    }
  } catch (error) {
    console.log(error);
  }
}
